module.exports = __webpack_public_path__ + "img/r4.fd871d4b.jpg";